export default __webpack_public_path__ + "static/media/signin-bg1.3391336c.webp";